import s from './Voiting.module.css';
import { fetchVoiting, voteUp, voteDown, addFavorites } from 'services/API/API';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';
import { BackButton } from 'components/BackButton/BackButton';
import { VoitingLabel } from 'components/MenuLabels/VoitinLabel/VoitingLabel';
import { CatImage } from 'pages/voiting/CatImage/CatImage';
import { useEffect } from 'react';
import { VotePanel } from 'pages/voiting/VotePanel/VotePanel';
import { useState } from 'react';
import { Log } from 'components/Log/Log';
import { Like } from 'components/iconComponent/Like';
import { DisLike } from 'components/iconComponent/DisLike';
import { FavoritesIcon } from 'components/iconComponent/FavoritesIcon';

const Voiting = () => {
  const [image, setImage] = useState(null);
  const [id, setId] = useState(null);
  const [logs, setLogs] = useState([]);
  const [status, setStatus] = useState(0);

  const getImage = () => {
    try {
      fetchVoiting().then(({ url, id }) => {
        if (id && url) {
          setImage(url);
          setId(id);
          setStatus(1);
          return;
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getImage();
  }, []);

  const logsHandler = (vote, icon) => {
    const newLog = {
      id,
      vote,
      time: new Date().getHours() + ':' + new Date().getMinutes(),
      icon,
    };

    setLogs(logs => {
      if (logs.length >= 4) {
        return [...logs.splice(0, 1), newLog];
      }
      return [...logs, newLog];
    });
  };

  const onVote = vote => {
    if (vote === 'Likes' && status) {
      voteUp(id);
      logsHandler(vote, <Like color={'#97EAB9'} width={20} height={20} />);
    }

    if (vote === 'Favorites' && status) {
      addFavorites(id);

      logsHandler(
        vote,
        <FavoritesIcon width={20} height={20} color={'#FF868E'} />
      );
    }

    if (vote === 'Dislikes' && status) {
      voteDown(id);
      logsHandler(vote, <DisLike color={'#FFD280'} width={20} height={20} />);
    }

    setStatus(0);
    getImage();
  };

  return (
    <div className={s.main}>
      <NavigationHeader />
      <div className={s.voitingContainer}>
        <div className={s.navigation}>
          <BackButton path={'/'} />
          <VoitingLabel />
        </div>

        <div className={s.container}>
          {image ? <CatImage imageUrl={image} /> : <h1>No such breed</h1>}
          <VotePanel onVote={onVote} />
        </div>
        <div className={s.logs}>
          {logs.map(({ id, vote, time, icon }) => {
            return <Log id={id} time={time} vote={vote} key={id} icon={icon} />;
          })}
        </div>
      </div>
    </div>
  );
};

export { Voiting };
